import React from "react";
import ThemeDefaultComponent from "../../components/ThemeDefaultComponent/ThemeDefaultComponent";
import ResetPasswordCard from "./components/ResetPasswordCard";
import useResetPasswordForm from "./hooks/useResetPasswordForm";

const ResetPassword = () => {
    const resetPasswordForm = useResetPasswordForm();

    return (
        <ThemeDefaultComponent>
            <ResetPasswordCard resetPasswordForm={resetPasswordForm} />
        </ThemeDefaultComponent>
    );
};

export default ResetPassword;
